import Cookies from 'js-cookie';
import BaseComponent from 'components/pages/SignIn';
import postSignIn from 'domains/api/sign_in';
import { useNavigate } from 'react-router';

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const onSubmit = (email: string, password: string) => {
    void postSignIn(email, password).then((response) => {
      if (
        response.accessToken &&
        response.client &&
        response.uid &&
        response.expiry
      ) {
        Cookies.set('_accessToken', response.accessToken);
        Cookies.set('_client', response.client);
        Cookies.set('_uid', response.uid);
        Cookies.set('_expiry', response.expiry);

        navigate('/');
      } else {
        navigate(0);
      }
    });
  };

  return <BaseComponent onSubmit={onSubmit} />;
};

export default SignIn;
